import React from "react"
import DownloadArea from "./DownloadArea"
import TransferContainer from "./timeline/styled/TransferContainer"
import TransferMessage from "./timeline/styled/TransferMessage"

const DownloadTransferMessage = ({ message }) => {
  return (
    <DownloadArea>
      <TransferContainer>
        <TransferMessage>{message}</TransferMessage>
      </TransferContainer>
    </DownloadArea>
  )
}

export default DownloadTransferMessage
